import {
  FETCH_CONTACTS_REQUEST,
  FETCH_CONTACTS_SUCCESS,
  FETCH_CONTACTS_FAILURE,
  CHANGE_CONTACT,
  CREATE_CONTACT_REQUEST,
  CREATE_CONTACT_SUCCESS,
  CREATE_CONTACT_FAILURE,
  CONTACT_ADDED,
  CONTACT_UPDATED,
  PATCH_CONTACT_REQUEST,
  PATCH_CONTACT_SUCCESS,
  PATCH_CONTACT_FAILURE,
} from './companyContactsTypes';

import { getAuthClient } from '../../library/drupal/DrupalAuth2';

const auth = getAuthClient();

export const fetchContacts = (companyUID) => {
  const url = `/jsonapi/node/fh_producer_contact?filter[contact-filter][condition][path]=field_first_handler.id&filter[contact-filter][condition][value]=${companyUID}&page[limit]=1500`;
  // A fresh options object per request: fetchWithAuthentication() adds the Authorization
  // header to the headers it is given, and sends nothing if one is already there.
  const makeOptions = () => ({
    method: 'GET',
    headers: new Headers({
      Accept: 'application/vnd.api+json',
      'Content-Type': 'application/vnd.api+json',
    }),
    mode: 'cors',
  });
  // The server caps the page size (jsonapi_defaults page_limit, 1,500 on prod), so follow the
  // `next` links: otherwise a handler with more contacts than that silently loses the rest.
  const MAX_PAGES = 20;
  const fetchAllPages = async () => {
    let contacts = [];
    let pageUrl = url;
    for (let page = 0; pageUrl && page < MAX_PAGES; page++) {
      const response = await auth.fetchWithAuthentication(
        pageUrl,
        makeOptions()
      );
      const data = await response.json();
      if (!Array.isArray(data.data)) {
        throw new Error(`Contacts request failed: ${response.status}`);
      }
      contacts = contacts.concat(data.data);
      const next = data.links && data.links.next && data.links.next.href;
      // `next` is an absolute URL; fetchWithAuthentication() wants a path on the API host.
      pageUrl = next ? new URL(next).pathname + new URL(next).search : null;
    }
    return contacts;
  };
  return (dispatch) => {
    dispatch(fetchContactsRequest);
    fetchAllPages()
      .then((contacts) => {
        dispatch(fetchContactsSuccess(contacts));
      })
      .catch((error) => {
        const errorMsg = error.message;
        dispatch(fetchContactsFailure(errorMsg));
      });
  };
};

export const createContact = (data) => {
  const url = `/jsonapi/node/fh_producer_contact`;
  const options = {
    method: 'POST',
    headers: new Headers({
      Accept: 'application/vnd.api+json',
      'Content-Type': 'application/vnd.api+json',
    }),
    mode: 'cors',
    body: JSON.stringify(data),
  };
  return async (dispatch) => {
    dispatch(createContactRequest());
    try {
      const response = await auth.fetchWithAuthentication(url, options);
      if (response.ok) {
        dispatch(createContactSuccess(JSON.stringify(response)));
        const data = await response.json();
        // Add the new contact from the POST response (same shape as a list item) instead of
        // refetching every contact, which took several seconds for large handlers.
        dispatch(contactAdded(data.data));
        const newContactID = data.data.id;
        dispatch(changeContact(newContactID));
        return data.data;
      } else {
        dispatch(createContactFailure('An error has occured.'));
      }
    } catch (error) {
      const errorMsg = error.message;
      dispatch(createContactFailure(errorMsg));
    }
    return null;
  };
};

export const patchContact = (contactUID, data) => {
  const url = `/jsonapi/node/fh_producer_contact/${contactUID}`;
  const options = {
    method: 'PATCH',
    headers: new Headers({
      Accept: 'application/vnd.api+json',
      'Content-Type': 'application/vnd.api+json',
    }),
    mode: 'cors',
    body: JSON.stringify(data),
  };
  return async (dispatch) => {
    dispatch(patchContactRequest());
    try {
      const response = await auth.fetchWithAuthentication(url, options);
      if (response.ok) {
        dispatch(patchContactSuccess(JSON.stringify(response)));
        const data = await response.json();
        // Swap in the saved contact from the PATCH response (same shape as a list item, and
        // as stored after Drupal's presave) instead of refetching every contact.
        dispatch(contactUpdated(data.data));
        return data.data;
      } else {
        dispatch(patchContactFailure('An error has occured.'));
      }
    } catch (error) {
      const errorMsg = error.message;
      dispatch(patchContactFailure(errorMsg));
    }
    return null;
  };
};

export const fetchContactsRequest = () => {
  return {
    type: FETCH_CONTACTS_REQUEST,
  };
};

export const fetchContactsSuccess = (contacts) => {
  return {
    type: FETCH_CONTACTS_SUCCESS,
    payload: contacts,
  };
};

export const fetchContactsFailure = (error) => {
  return {
    type: FETCH_CONTACTS_FAILURE,
    payload: error,
  };
};

export const changeContact = (id) => {
  return {
    type: CHANGE_CONTACT,
    id: id,
  };
};

export const contactAdded = (contact) => {
  return {
    type: CONTACT_ADDED,
    payload: contact,
  };
};

export const contactUpdated = (contact) => {
  return {
    type: CONTACT_UPDATED,
    payload: contact,
  };
};

export const createContactRequest = () => {
  return {
    type: CREATE_CONTACT_REQUEST,
  };
};

export const createContactSuccess = (createResult) => {
  return {
    type: CREATE_CONTACT_SUCCESS,
    payload: createResult,
  };
};

export const createContactFailure = (error) => {
  return {
    type: CREATE_CONTACT_FAILURE,
    payload: error,
  };
};

export const patchContactRequest = () => {
  return {
    type: PATCH_CONTACT_REQUEST,
  };
};

export const patchContactSuccess = (patchResult) => {
  return {
    type: PATCH_CONTACT_SUCCESS,
    payload: patchResult,
  };
};

export const patchContactFailure = (error) => {
  return {
    type: PATCH_CONTACT_FAILURE,
    payload: error,
  };
};
